import { useMemo } from 'react';
import { Provider } from 'redux-zero/react';
import { bindActions } from 'redux-zero/utils';
import { ServiceApiContext } from '@embed/components/Player3/contexts/serviceApi';
import { useApiWithParams } from '@embed/hooks/useApi';
import { actions as storeActions, storeFactory } from '@embed/store/fwn';
export const WidgetWrapper = ({ initialParams, widgetParams, children, }) => {
    const store = useMemo(() => storeFactory({ initialParams, widgetParams }), [initialParams, widgetParams]);
    const api = useApiWithParams(store.getState().params);
    // TODO: get back to it when other type errors are fixed
    // https://fireworkhq.monday.com/boards/404854566/views/38104975/pulses/1826945309
    const actions = bindActions(storeActions, store);
    actions.storeLastActivity();
    return (<Provider store={store}>
      <ServiceApiContext.Provider value={api}>
        {children(actions)}
      </ServiceApiContext.Provider>
    </Provider>);
};
